module.exports = __webpack_public_path__ + "static/media/DR_bg.4e1d87fa.svg";